import React from "react";

interface ProgressBarProps {
  value: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ value }) => {

  const lower = 0.4;
  const upper = 1;
  const x = (upper - lower) * value / 100 + lower;

  return (
    <div>
      <div
        //className="bg-primary"
        style={{
          height: "12px",
          position: "relative",
          borderRadius: "6px",
          backgroundColor: "#E8E6EB"
        }}>
        <div
          className="bg-primary" // returns to non gradient solid colour
          style={{
            height: "100%",
            width: value + "%",
            position: "absolute",
            borderRadius: "6px",
            //backgroundImage: `linear-gradient(to right, rgba(120,40,140,${lower}), rgba(120,40,140,${x}))`,
            //backgroundColor: "white"
          }}>
        </div>
      </div>
    </div>);
}

export default ProgressBar;
